import $ from 'jquery';
import React from 'react';
import ReactDOM from 'react-dom';
import Utils from 'medscape/utils';
import Nav from 'infosite/navigation';
import InfositeHelpers from 'infosite/helpers';
import cx from 'classnames';
import Article from './article';
import SideMenu from 'infosite/mobile-menu/side-menu'


export default class Template extends React.Component{
    constructor(props){
        super(props);
        this.state = {}
        InfositeHelpers.setBrowserHistory(props.route.history);
    }
   
    getTemplate(){
        let template;
        let templateType = this.props.page.template;

        if(window.medscape.isMobile){
            templateType = "mobile";
        }
        if(this.props.navigation.links.length==0){
            templateType = "default";
        }
        switch(templateType){
            case "navigation":
                template = NavTemplate(this.props);
                break;
            case "mobile":
                template = MobileTemplate(this.props);
                break;
            default:
                template = DefaultTemplate(this.props);
        }
        return template;
    }

    render() {

        const template = this.getTemplate();
        const className = cx({
            'page-template-wrapper': true,
            'flow-invert': !this.props.isMobile && this.props.navigation.desktop.position=='right',
            'flow-column': !this.props.isMobile && this.props.navigation.desktop.position=='top',

        })
        return (
            <section className={className}>
                {template}
            </section>
        )
    }
}

Template.propTypes={
    "page": React.PropTypes.object.isRequired,
    "navigation": React.PropTypes.object.isRequired,
    "route": React.PropTypes.object.isRequired,
    "isMobile": React.PropTypes.bool,
    "isi": React.PropTypes.object
}
Template.defaultProps={
    "isMobile": (window.medscape.isMobile ? window.medscape.isMobile : false)
}

const DefaultTemplate = (props) => (
    <section className="main-content default-template">
        <Article key="infosite-article" page={props.page} isi={props.isi} />
    </section>
)

const NavTemplate = (props) => (
    <section className="main-content nav-template">
        <Nav navigation={props.navigation} route={props.route} />
        <Article key="infosite-article" page={props.page} isi={props.isi} />
    </section>
)

const MobileTemplate  = (props) => (
    <section className="mobile-template">
        <SideMenu navigation={props.navigation} route={props.route} />
        <section className="main-content default-template" id="page-wrap">
            <Article key="infosite-article" page={props.page} isi={props.isi} />
        </section>
    </section>
)




// WEBPACK FOOTER //
// ./src/app/page-content/template.jsx